export const PrintMethods = {
    HTML: "HTML",
    PDF: "PDF"
}